import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { IoWarningOutline } from "react-icons/io5"
import { RiExternalLinkLine } from "react-icons/ri"
import ApiContext from "src/provider/API/call-service"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AbsoluteContainer, AppLabel, AppSpan, AppText, Button, CustomContainer, FlexColumn, FlexRow, Form, FormGroup, GridContainer } from "src/style"
import { Table } from "src/component"
import { disputeColumns, allDisputeData, disputeData, requestData } from "src/utils/tableLayout"
import { ExportTypes } from "src/popup"
import { IDispute_ServiceRequest } from "src/model"

export const AllDisputes: React.FC<any> = ({toggleTo, handleOnSelect}) => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {notifier} = useContext(VisibilityContext)
    const [navPosition, setNavPosition] = useState(0)
    const [tableTypePosition, setTableTypePosition] = useState(0)
    const [requests_disputes, setRequests_Disputes] = useState<Array<IDispute_ServiceRequest> | null>(null)
    const [disputes, setDisputes] = useState<Array<IDispute_ServiceRequest> | null>(null)
    const [serviceRequests, setServiceRequests] = useState<Array<IDispute_ServiceRequest> | null>(null)
    const [dateOpenned, setDateOpenned] = useState('')
    const [isExport, setIsExport] = useState(false)

    useEffect(() => {
        handleFetchRequestAndDisputes()
    }, [])

    function handleSelectedRow(data: any) {
        handleOnSelect(data)
        toggleTo('dispute-details')
    }

    async function handleFetchRequestAndDisputes () {
        const response = await API.getServiceRequestsAndDisputes(dateOpenned)
        if (response) setRequests_Disputes(response)
    } 

    async function handleFetchDisputes () {
        const response = await API.getDisputes(dateOpenned)
        if (response) setDisputes(response)
    }

    async function handleFetchServiceRequests () {
        const response = await API.getServiceRequests(dateOpenned)
        if (response) setServiceRequests(response)
    }

    async function handleTableType (position: number) {
        setTableTypePosition(position)
        if (position === 0) handleFetchRequestAndDisputes()
        else if (position === 18.7) handleFetchDisputes()
        else if (position === 30) handleFetchServiceRequests()
    }

    async function onStatusChange (id: number, status: string) {
        if (!['Resolved', 'Unresolved'].includes(status)) {
            const val = JSON.parse(status)
            return handleSelectedRow(val)
        }

        const response = await API.changeDisputeOrRequestStatus(id, status)
        if (response) {
            await handleTableType(tableTypePosition)
            notifier.show(response.message || `Dispute/Request Marked as ${status}`, null, 'success')
        }
    }

    return (
        <>
            <CustomContainer>
                <FlexRow 
                    justifyContent="space-between" alignItems="flex-end" gap="2" wrap="wrap"
                >
                    <CustomContainer width="45">
                        <AppLabel textSize="2" fontWeight="600" color="#181D27">Resolve Disputes & Manage requests</AppLabel>
                        <AppText color="#6F767C" topMargin="0.2">
                            See all Disputes & requests, resolve and manage requests them.
                        </AppText>
                    </CustomContainer>
                    <FlexRow width="auto" sizeUnit="">
                        <CustomContainer 
                            padding="1" bgColor="#FFEBEC" radius="0.4"
                            width="20" topPadding="0.8" bottomPadding="0.8"
                        >
                            <AppSpan color="#F16063" rightMargin="0.6" textSize="1.6"><IoWarningOutline/></AppSpan>
                            <AppSpan color="#F16063" textSize="1.2">18 Activities need attention</AppSpan>
                        </CustomContainer>
                        <Button 
                            width='9.9' borderColor='#4C6FFF' height='3.6'
                            hoverBgColor='#4C6FFF' hoverColor='#ffffff' titleSize='1.2'
                            bgColor='transparent' color='#4C6FFF' leftMargin='1.5'
                            onClick={() => setIsExport(true)}
                        >
                            <RiExternalLinkLine style={{fontSize: '1.4rem'}} /> Export
                        </Button>
                    </FlexRow>
                </FlexRow>
                <GridContainer 
                    height="4" topMargin="6" bottomMargin="3" 
                    width="32.4" radius="0.4" bgColor="#F7FAFC"
                >
                    <AbsoluteContainer width='16.2' top="0" left={`${navPosition}`}>
                        <CustomContainer borderColor="#4C6FFF" height="4" radius="0.4" />
                    </AbsoluteContainer>
                    <FlexRow>
                        <AppSpan 
                            color={navPosition === 0 ? "#4C6FFF" : "#A0AEC0"}
                            fontWeight={navPosition === 0 ? "600" : "400"}
                            textSize="1.2" cursor="pointer"
                            width='50' sizeUnit='%' align='center'
                            onClick={() => setNavPosition(0)}
                        >
                            Disputes & Request list
                        </AppSpan>
                        <AppSpan 
                            color={navPosition === 16.2 ? "#4C6FFF" : "#A0AEC0"}
                            fontWeight={navPosition === 16.2 ? "600" : "400"}
                            textSize="1.2" cursor="pointer"
                            width='50' sizeUnit='%' align='center'
                            //onClick={() => setNavPosition(16.2)}
                            onClick={() => navigate('/customer-support/customer-search')}
                        >
                            Find customer
                        </AppSpan>
                    </FlexRow>
                </GridContainer>
                { navPosition === 0 &&
                    <CustomContainer>
                        <CustomContainer 
                            height="2.7" width="45" topMargin="2.5" bottomMargin="4"
                            style={{borderBottom: '1px solid #EDF2F7'}}
                        >
                            <AbsoluteContainer bottom="0" left={`${tableTypePosition}`}>
                                <CustomContainer bgColor="#4C6FFF" width={tableTypePosition === 0 ? '15.5' : "8"} height="0.3" />
                            </AbsoluteContainer>
                            <FlexRow gap="4">
                                <AppSpan 
                                    color={tableTypePosition === 0 ? "#1A202C" : "#A0AEC0"}
                                    textSize="1.2" leftPadding="1" rightPadding="1" cursor="pointer"
                                    onClick={() => handleTableType(0)}
                                >
                                    All Disputes & Requests
                                </AppSpan>
                                <AppSpan 
                                    color={tableTypePosition === 18.7 ? "#1A202C" : "#A0AEC0"}
                                    textSize="1.2" leftPadding="1" rightPadding="1" cursor="pointer"
                                    onClick={() => handleTableType(18.7)}
                                >
                                    Disputes
                                </AppSpan>
                                <AppSpan 
                                    color={tableTypePosition === 30 ? "#1A202C" : "#A0AEC0"}
                                    textSize="1.2" leftPadding="1" rightPadding="1" cursor="pointer"
                                    onClick={() => handleTableType(30)}
                                >
                                    Requests
                                </AppSpan>
                            </FlexRow>
                        </CustomContainer>

                        <Table 
                            tableData={tableTypePosition === 0 ? requests_disputes : tableTypePosition === 18.7 ? disputes : serviceRequests}
                            tableColumns={disputeColumns(onStatusChange)}
                            onRowClickMethod={handleSelectedRow}
                            customStyle
                            canSearch
                            canDateSearch
                        />
                    </CustomContainer>
                }
                { navPosition === 16.2 
                    // <CustomContainer topMargin="14" className="customer-search-wrapper">
                    //     <FlexColumn 
                    //         width="52.9" height="41.9" borderColor="#E2E8F0"
                    //         radius="0.8" justifyContent="flex-start" topPadding="4"
                    //         bottomPadding="4" leftMargin="25"
                    //     >
                    //         <CustomContainer width="80" sizeUnit="%">
                    //             <AppText textSize="2" fontWeight="600" color="#27272E" bottomMargin="0.7">Customer details</AppText>
                    //             <AppSpan textSize="1.6" color="#27272E">Directly search and view customer details</AppSpan>
                    //             <Form topMargin="6">
                    //                 <FormGroup>
                    //                     <label>Search customer using</label>
                    //                     <input 
                    //                         placeholder='Name, phone number, email or BVN'
                    //                         name='search'
                    //                     />
                    //                 </FormGroup>
                    //                 <Button
                    //                     width='100' sizeUnit='%' borderColor='#4C6FFF' height='4.5'
                    //                     hoverBgColor='#ffffff' hoverColor='#4C6FFF'
                    //                 >
                    //                     Find customer
                    //                 </Button>
                    //             </Form>
                    //         </CustomContainer>
                    //     </FlexColumn>
                    // </CustomContainer>
                }
            </CustomContainer>
            { isExport &&
                <ExportTypes
                    customClass="dispute-export-popup"
                    close={() => setIsExport(false)} 
                    data={tableTypePosition === 0 ? requests_disputes : tableTypePosition === 18.7 ? disputes : serviceRequests}
                />
            }
        </>
    )
}